import { Injectable } from '@angular/core';
import { TranslationService } from '@app/shared/translation/translation.service';
import _ from 'underscore';
import { STATE_REPORT } from '@app/shared/app-states';
import { ReportFiltersUtil } from '@app/shared/report/report-filters-util.service';
import { IObject } from '@type_definitions/datatypes';
import { ReportParameterCode, ReportParameterShortCode } from '@app/main/report/report-state.util';

export interface IAuditLink {
  title?:string;
  state?:string;
  stateParams?:IObject;
}

@Injectable()
export class BPProfilesAuditDataService {

  constructor(
    private translationService:TranslationService,
    private reportFiltersUtil:ReportFiltersUtil
  ) {
    /**/
  }

  public getAuditLinks(companyCountryId:number, companyId:number):IAuditLink[] {
    const links:IAuditLink[] = [
      {
        title: 'BPPROFILES.AUDIT.HISTORY_TNC',
        state: STATE_REPORT,
        stateParams: {
          [ReportParameterCode.REPORT_ID]: 191,
          [ReportParameterShortCode.AUTO_LOAD]: true,
          [ReportParameterShortCode.FILTERS]: this.reportFiltersUtil.filtersToParam({
            Pacomnm: companyCountryId
          })
        }
      },
      {
        title: 'BPPROFILES.AUDIT.HISTORY_SLA',
        state: STATE_REPORT,
        stateParams: {
          [ReportParameterCode.REPORT_ID]: 192,
          [ReportParameterShortCode.AUTO_LOAD]: true,
          [ReportParameterShortCode.FILTERS]: this.reportFiltersUtil.filtersToParam({
            Decomnm: companyId
          })
        }
      },
      {
        title: 'BPPROFILES.AUDIT.HISTORY_BP_PROFILE',
        state: STATE_REPORT,
        stateParams: {
          [ReportParameterCode.REPORT_ID]: 217,
          [ReportParameterShortCode.AUTO_LOAD]: true,
          [ReportParameterShortCode.FILTERS]: this.reportFiltersUtil.filtersToParam({
            Pacomnm: companyCountryId
          })
        }
      },
      {
        title: 'BPPROFILES.AUDIT.HISTORY_COMPANY_COUNTRY',
        state: STATE_REPORT,
        stateParams: {
          [ReportParameterCode.REPORT_ID]: 218,
          [ReportParameterShortCode.AUTO_LOAD]: true,
          [ReportParameterShortCode.FILTERS]: this.reportFiltersUtil.filtersToParam({
            Company: companyId
          })
        }
      }
    ];

    _.forEach(links, (link:IAuditLink) => {
      link.title = this.translationService.instant(link.title);
    });

    return links;
  }
}